import { cn } from "@/lib/utils";
import styles from "./SlideUpAnimation.module.css";

export interface SlideUpAnimationProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A reusable slide-up animation component that fades in while sliding up from below
 * Perfect for drawer contents, modals, or any content that needs a smooth entrance
 */
export function SlideUpAnimation({
  children,
  className,
}: SlideUpAnimationProps) {
  return (
    <div className={cn(styles.slideUpAnimation, className)}>{children}</div>
  );
}
